import InformationsModalListView from "./informations-modal_list.html";

angular.module("informations")

    .controller("InformationsListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$stateParams', '$state',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter,  $stateParams, $state) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("INFORMATION_WRITE");
            $scope.showReturnToEvent = false;
            $scope.currentState = $state.current.name;


            if ($scope.currentState === 'informations.list') {
                $rootScope.title = $filter('translate')('events.informations');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('events.informations') }
                ];
            } else {
                Restangular.one('Events', $stateParams.id).get().then(function (results) {
                    $rootScope.breadcrumb = [
                   { title: $filter('translate')('events.title'), url: "events.list" },
                   { title: results.name, url: "events.edit({ id: " + $stateParams.id + " })" },
                   { title: $filter('translate')('events.informations') }
                    ];
                    $rootScope.title = results.name + " - " + $filter('translate')('events.informations');
                });
            }



            $scope.event = $stateParams.id;

            $scope.search = {
                event_id: angular.isDefined($stateParams.id) && $stateParams.id != "" ? parseInt($stateParams.id) : undefined
            };
                        

            $scope.InformationTypesOptions = [];

            $scope.showInformations = false;

            Restangular.all('Users').getList().then(function (persons) {
                $scope.selectPersons = persons;
                $scope.selectPersons.unshift({
                    id: null,
                    name: $filter('translate')('informations.all')
                });
                $scope.search.user = $scope.selectPersons[0];
            });

            Restangular.all('InformationsTypes').getList().then(function (types) {
                $scope.selectTypes = types;

                $scope.selectTypes.unshift({
                    id: null,
                    name: $filter('translate')('informations.all')
                });
                $scope.search.information_type = $scope.selectTypes[0];
            });

            /*Restangular.all('Events').getList({ is_template: false }).then(function (events) {
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('informations.all')
                });
            });*/
            var options = {
                searchName: "",
                is_template: false
            };
            Restangular.all('Events/AllEvents').getList(options).then(function (events) {
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('informations.all')
                });
            });

            $scope.gridOptionsInformations = {
                pdfTitle: $filter('translate')('informations.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'date', width: 120, displayName: $filter('translate')('informations.date'), cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                        enableFiltering: false, enableColumnMenu: false,
                        customFormatFn: function (value) {
                            if (value != null) {
                                var fecha = new Date(value);
                                return $filter('date')(fecha, 'dd/MM/yyyy HH:mm');
                            }
                            return "";
                        },
                    },
                    { name: 'name', displayName: $filter('translate')('informations.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: 'information_type', width: 120, field: 'FK_informations_informations_types.name', displayName: $filter('translate')('informations.type'),
                        enableFiltering: false
                    },
                    { name: 'event_name', field: 'FK_informations_events.name', displayName: $filter('translate')('informations.event'), enableFiltering: false, visible: ($scope.event != null ? false : true) },
                    { name: 'user_name', field: 'FK_informations_users.name', displayName: $filter('translate')('informations.publisher'), enableFiltering: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('informations.button_edit'), action: 'ui-sref="informations.edit({information_id:row.entity.id})" ng-if="grid.appScope.allowWrite && grid.appScope.currentState==\'informations.list\'"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('informations.button_edit'), action: 'ui-sref="events.edit.informations.edit({information_id:row.entity.id, event:grid.appScope.event})" ng-if="grid.appScope.allowWrite && grid.appScope.currentState==\'events.edit.informations\'"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('informations.button_delete'), action: 'ng-click="$event.stopPropagation();grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    }

                ],
                getData: function (options) {
                    options.date_from = $scope.search.date_from;
                    options.date_to = $scope.search.date_to;
                    options.description = $scope.search.description;

                    if ((angular.isUndefined(options.information_type) || options.information_type == "") && angular.isDefined($scope.search.information_type))
                        options.information_type_id = $scope.search.information_type.id;

                    if ((angular.isUndefined(options.event_name) || options.event_name == "") && angular.isDefined($scope.search.event_id))
                        options.event_id = $scope.search.event_id;

                    if ((angular.isUndefined(options.user_name) || options.user_name == "") && angular.isDefined($scope.search.user))
                        options.user_id = $scope.search.user.id;
                    return Restangular.all('Informations').getList(options);
                }
            };

            $scope.goToEdit = function (rowEntity) {
                if ($scope.currentState == "informations.list" && $scope.allowWrite)
                    $state.go("informations.edit", { information_id: rowEntity.id });
                else if ($scope.currentState == "events.edit.informations" && $scope.allowWrite)
                    $state.go("events.edit.informations.edit", { information_id: rowEntity.id, event: $scope.event });

            };


            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('informations.button_delete'),
                    message: $filter('translate')('informations.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Informations', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('informations.delete_success'));
                            $scope.gridOptionsInformations.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };

            /**
             * Abre un modal que permite añadir varios archivos de golpe.
             */
            $scope.addMultiple = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: InformationsModalListView,
                    controller: "InformationsModalListCtrl",
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        options: function () {
                            return {event_id: $stateParams.id};
                        }
                    }
                });

                $modalInstance.result.then(function (success) {
                    if (angular.isDefined($scope.gridOptionsInformations)) $scope.gridOptionsInformations.loadData(false);
                });
            };

        }])

;